export function mockLocation({ pathname = '/', hostname = 'test.smarttbot.com' }) {
    global.window = Object.create(window);
    Object.defineProperty(window, 'location', {
        value: { pathname, hostname },
        writable: true
    });
}
